class OnlineDesignerActionTypes {
    static MAIN_NAME = 'OD_';
    static loadProduct_NAME =
        OnlineDesignerActionTypes.MAIN_NAME + 'LOAD_PRODUCT_';
    static selected_NAME = OnlineDesignerActionTypes.MAIN_NAME + 'SELECTED_';
    static team_NAME = OnlineDesignerActionTypes.MAIN_NAME + 'TEAM_';

    static loadProduct = {
        start: OnlineDesignerActionTypes.loadProduct_NAME + 'START',
        success: OnlineDesignerActionTypes.loadProduct_NAME + 'SUCCESS',
        fail: OnlineDesignerActionTypes.loadProduct_NAME + 'FAIL',
        reset: OnlineDesignerActionTypes.loadProduct_NAME + 'RESET',
    };

    static selected = {
        setFabric: OnlineDesignerActionTypes.selected_NAME + 'SET_FABRIC',
        setSizes: OnlineDesignerActionTypes.selected_NAME + 'SET_SIZES',
    };

    static team = {
        setMembers: OnlineDesignerActionTypes.team_NAME + 'SET_MEMBERS',
    };
}

export default OnlineDesignerActionTypes;
